





































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { zoneService } from "@/services/zone";
import { deskService } from "@/services/desk";
import { Zone } from "@/swagger/models";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "moveDesksModal",
    components: {},
})
export default class moveDesksModal extends Vue {
    @Prop({ required: true })
    deskIds: number[];

    @Prop({ required: true })
    officeId: number;

    open: boolean = false;

    loading = false;
    moving = false;
    zones: Zone[] = [];

    selectedZone: Zone = null;

    async moveDesks() {
        // await deskService.moveDesks;
        if (!confirm(`Are you sure you want to move ${this.deskIds.length} desk(s) to ${this.selectedZone.name}?`))
            return;

        let successfulMoves = 0;
        for (const id of this.deskIds) {
            try {
                await deskService.patch(id, {
                    // @ts-ignore
                    zoneId: this.selectedZone.id,
                });
                successfulMoves++;
            } catch (e) {
                console.warn(e);
            }
        }

        await this.$tosti.success({ message: `${successfulMoves} desk(s) were moved to ${this.selectedZone.name}` });
        this.open = false;
        this.$emit("save");
    }

    @Watch("open")
    async refreshData() {
        if (!this.open) return;

        try {
            this.loading = true;
            this.zones = (
                await zoneService.findNew({
                    params: {
                        office: this.officeId,
                    },
                })
            ).data;
        } catch (e) {
            console.warn(e);
        } finally {
            this.loading = false;
        }
    }
}
